import {ErrorHandler, Injectable} from '@angular/core';
import * as Sentry from '@sentry/browser';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable()
export class GeneralErrorHandleService implements ErrorHandler {
  static SENTRY_DEFAULT_FINGERPRINT_VALUES = '{{ default }}';

  constructor() { }

  public handleError( error: any) {
    console.warn(error.stack);
    // don't report error with status from 400 and above to Sentry
    if (error && error instanceof HttpErrorResponse && error.status >= 400 && error.status < 500) {
      return;
    }

    let reported_error;
    let errorPath;

    // The below is pretty silly, but for Sentry to report stacktrace the
    // captureException must be given an Error object.
    // The `instanceof` check only works if the Error was instantiated in the same
    // JS context as this code, otherwise it'll be treated as simply an object.
    // That's whhy we have all the checks below.
    if (error && error && error.originalError instanceof Error) {
      reported_error = error.originalError;
    } else if (error && error && error.originalError && error.originalError.message ) {
      reported_error = new Error(error.originalError.message);
      errorPath = error.url ? this.getErrorPath(error.url, error.originalError.message) : null;
    } else if (error instanceof Error) {
      reported_error = error;
    } else if (error && error.message) {
      reported_error = new Error(error.message);
      errorPath = error.url ? this.getErrorPath(error.url, error.message) : null;
    } else {
      reported_error = new Error(error.toString()); // We need to know what is happening
    }

    if (errorPath) {
      Sentry.withScope((scope) => {
        scope.setFingerprint([GeneralErrorHandleService.SENTRY_DEFAULT_FINGERPRINT_VALUES, errorPath]);
        const eventId = Sentry.captureException(reported_error);
      });
    } else {
      const eventId = Sentry.captureException(reported_error);
    }
  }

  private getErrorPath(errorUrl: string, errorMessage: string) {
    const url = errorUrl.indexOf('?') >= 0 ? errorUrl.split('?')[0] : errorUrl;
    return (url + '-' + errorMessage).replace(/\d+/g, 'N');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/general-error-handle.service.ts